<div>
  <app-data-table [sortActive]="sortActive" [data]="practiceLogs || []" [displayedColumns]="displayedColumns" [columns]="columns"
    [actions]="actions" [hasPagination]="false" [hasHeader]="true">
  </app-data-table>
</div>